import React from "react";
import Switch from "react-switch";

const ToggleSwitch = ({
  checked = false,
  onChange = () => {}, // ⭐ Default safe function
  onColor = "#86d3ff",
  offColor = "#ffb3b3",
  handleColor = "#ffffff",
  width = 48,
  height = 20,
  handleDiameter = 30,
  checkedIcon = false,
  uncheckedIcon = false,
  boxShadow = "0px 1px 5px rgba(0,0,0,0.6)",
  activeBoxShadow = "0px 0px 1px 10px rgba(0,0,0,0.2)",
  showStatus = true,
  className = "",
}) => {
  return (
    <div className={`flex justify-between ${className}`}>
      {showStatus && (
        <span
          className={`font-semibold ${
            checked ? "text-green-500" : "text-red-500"
          }`}
        >
          {checked ? "Active" : "Inactive"}
        </span>
      )}

      <Switch
        checked={checked}
        onChange={onChange}  
        onColor={onColor}
        offColor={offColor}
        onHandleColor={handleColor}
        handleDiameter={handleDiameter}
        uncheckedIcon={uncheckedIcon}
        checkedIcon={checkedIcon}
        boxShadow={boxShadow}
        activeBoxShadow={activeBoxShadow}
        height={height}
        width={width}
      />
    </div>
  );
};

export default ToggleSwitch;
